function JobCategoriesHumanResourcesIcon({ color = "#191515" }) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.479 58.668C2.479 60.1406 3.67171 61.3346 5.14567 61.3346C6.61963 61.3346 7.81234 60.1406 7.81234 58.668C7.81234 49.2578 13.2297 40.9269 21.6738 36.9873C24.5962 38.8864 28.0728 40.0013 31.8097 40.0013C35.5609 40.0013 39.0508 38.8789 41.98 36.9665C44.5008 38.1564 46.8369 39.7575 48.7811 41.7005C53.3149 46.2357 55.8123 52.2617 55.8123 58.668C55.8123 60.1406 57.005 61.3346 58.479 61.3346C59.953 61.3346 61.1457 60.1406 61.1457 58.668C61.1457 50.8372 58.0936 43.4727 52.5519 37.9297C50.6976 36.0744 48.5425 34.4836 46.2303 33.172C48.8815 29.9482 50.4764 25.8245 50.4764 21.3346C50.4764 11.0417 42.1014 2.66797 31.8097 2.66797C21.5181 2.66797 13.1431 11.0417 13.1431 21.3346C13.1431 25.8136 14.7314 29.9272 17.3709 33.1476C8.2168 38.3016 2.479 47.9315 2.479 58.668ZM31.8097 8.0013C39.1613 8.0013 45.1431 13.9831 45.1431 21.3346C45.1431 28.6862 39.1613 34.668 31.8097 34.668C24.4582 34.668 18.4764 28.6862 18.4764 21.3346C18.4764 13.9831 24.4582 8.0013 31.8097 8.0013Z"
        fill={color}
      />
    </svg>
  );
}

export default JobCategoriesHumanResourcesIcon;
